import React from 'react'

interface TitlesType {
  title?: React.ReactNode
  subtitle?: React.ReactNode
  text?: React.ReactNode
  id?: string
}

const Titles: React.FC<TitlesType> = ({ title, subtitle, text, id }) => {
  return (
    <div id={id} className="mb-[64px] text-center">
      {title && <div className="md:font-regular mb-24 font-medium text-purple-500">{title}</div>}
      {subtitle && <h2 className="text-d6 md:text-d4 font-bold">{subtitle}</h2>}
      {text && <div className="mt-16 text-gray-700">{text}</div>}
    </div>
  )
}

export default Titles
